import { render, staticRenderFns } from "./addClasse.vue?vue&type=template&id=86321ac2&"
import script from "./addClasse.vue?vue&type=script&lang=js&"
export * from "./addClasse.vue?vue&type=script&lang=js&"
import style0 from "./addClasse.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports